import { App } from 'vue';
import Editor from './CKEditor.vue';

export default function config(app: App): void {
    app.component('Editor', Editor);
}
